<template lang="pug">
  .locale-changer(v-bind:class="variant")
    select(v-model="$i18n.locale" v-bind:class="variant")
      option(v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang") {{ languages[lang] }}
</template>

<script>
  export default {
    name: 'locale-changer',
    props: ['variant'],
    data () {
      return { 
        langs: this.$i18n.availableLocales,
        languages: {
            en: 'English',
            pl: 'Polskie',
            sk: 'lovenský',
            hu: 'Magyar',
            el: 'Ελληνικά'
        }
      }
    },
    mounted() {
      // console.log(this.i18)
      // console.log();
    }
  }
</script>

<style lang="scss">
  .locale-changer {
    .lang-prompt {
      margin-left:11px;
      font-size:13px;
    }
    &.right {
      float:right;
    }
    select {
      -webkit-appearance: none; 
      -moz-appearance: none;
      appearance: none;
      cursor:pointer;
      height: 55px;
      border:0px none;
      font-size:13px;
      min-width:100px;
      text-indent:9px;
      background-color: $gradient-9;
      background-image:url('~@/assets/images/arrow-down-gray.svg');
      background-repeat: no-repeat;
      background-position: center right 12px;
      background-size:7px;
      color: $gradient-2;
      &.right {
        float:right;
      }
      &.small {
        height:36px;
      }
      &.light {
        background-color:#f0f0f0;
        border:2px solid $gradient-5;
        color: $gradient-5;
      }
    }
  }
</style>